module.exports = __webpack_public_path__ + "static/shopping-with-crypto-5d2d707593cf31d02834a013b0dc3171.svg";